export const STEP_INFO = {
  localizationKeyPrefix:
    'Geographic::StandCycleRotationHarvestPreparation.StepInventoryValidation',
};
export const COLUMN_HEADER_KEYS = {
  inventoryValidated: 'Geographic::Entity.StandCycleRotation.IsInventoryValidated',
  inventoryType: 'Inventory::Entity.CalculationResult.InventoryType',
  inventoryYear: 'Inventory::Entity.CalculationResult.InventoryYear',
  inventoryDate: 'Inventory::Entity.CalculationResult.InventoryDate',
  stand: 'Planning::Entity.Stand.Name',
  cycle: 'Geographic::Entity.Cycle',
  rotation: 'Geographic::Entity.Rotation',
  area: 'Planning::Entity.Stand.StandArea',
  productivityParameters: 'Geographic::Entity.StandCycleRotation.ProductivityParameter',
  dab: 'Geographic::Entity.StandCycleRotation.Dab',
  applyHerbicide: 'Geographic::Entity.StandCycleRotation.ApplyHerbicide',
  stumpCandidateToRegrowth: 'Geographic::Entity.StandCycleRotation.IsStumpCandidateToRegrowth',
  applyFeller: 'Geographic::Entity.StandCycleRotation.ApplyFeller',
  measurementType: 'WoodSupply::Entity.MeasurementType',
};
